<template>
  <div class="row pb-5" v-if="plan">
    <div class="col-12 mb-4">
      <div class="bg-secondary rounded p-4">
        <img src="/images/selected-plain-icon.svg" alt="" class="selected-plain-icon">
        <p class="h4 mb-0 text-white">{{ plan.title }} </p>
        <p class="text-white mb-0" v-if="appliedCoupon && appliedCoupon.duration !== 'FOREVER'">
          <span
            class="h4 text-white">{{ formattedNewPrice }}</span> {{ formattedRecurrence }}
          per
          <span v-if="appliedCoupon.duration === 'ONCE'">la prossima transazione</span>
          <span v-if="appliedCoupon.duration === 'REPEATING'">{{ appliedCoupon.duration_in_months }} mesi</span>
          poi
        </p>
        <p class="text-white">
          <span
            class="h4 text-white mr-2"
            :style="{
              textDecoration: appliedCoupon && couponDurationForever ? 'line-through': 'none',
            }">{{ formattedPrice }} </span>
          <span
            class="h4 text-white mr-2"
            v-if="appliedCoupon && appliedCoupon.percent_off !== null && couponDurationForever">
            {{ appliedCoupon.percent_off }}%
          </span>
          <span v-else>{{ formattedRecurrence }} dopo la prova.</span>
        </p>
        <p class="text-white" v-if="appliedCoupon && couponDurationForever">
          <span class="h4 text-white mr-2">{{ formattedNewPrice }} </span>
          {{ formattedRecurrence }} dopo la prova.
        </p>
        <p class="mb-0 text-white">
          {{ plan[`${recurrence}_incentive`] }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "PlanInfo",
  props: {
    product: String,
    recurrence: String,
    appliedCoupon: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      plan: undefined
    }
  },
  computed: {
    formattedPrice() {
      const price = this.plan[`${this.recurrence}_price`] / 100;
      return this.formatPrice(price);
    },
    formattedRecurrence() {
      switch (this.recurrence) {
        case 'monthly':
          return 'al mese'
          break;
        case 'yearly':
          return "all'anno"
          break;
      }
    },
    formattedNewPrice() {
      const planPrice = this.plan[`${this.recurrence}_price`] / 100;
      let newPrice = planPrice;
      if (this.appliedCoupon.amount_off !== null) {
        newPrice = planPrice - this.appliedCoupon.amount_off;
      } else {
        newPrice = planPrice - (planPrice / 100 * this.appliedCoupon.percent_off);
      }

      return this.formatPrice(newPrice);
    },
    couponValid() {
      return this.appliedCoupon && this.appliedCoupon.valid;
    },
    couponDurationForever() {
      return this.couponValid && this.appliedCoupon.duration === 'FOREVER';
    }
  },
  methods: {
    formatPrice(price) {
      const formatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      });

      return formatter.format(price);
    }
  },
  apollo: {
    plan: {
      query: gql`query ($product: String!) {
        plan(product: $product) {
            title
            monthly_incentive
            yearly_incentive
            monthly_price
            yearly_price
        }
      }`,
      variables() {
        return {
          product: this.$props.product
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
